import { metaAccount } from '@/router/meta-config'
const permissionKey = 'INFOPAGE'

export default [
  {
    path: '/info-pages',
    name: 'page-info-pages',
    component: () => import('@/pages/infoPages'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/info-page/new',
    name: 'page-info-page-new',
    component: () => import('@/pages/infoPage'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/info-page/:id',
    name: 'page-info-page',
    component: () => import('@/pages/infoPage'),
    props: (route) => ({ id: Number(route.params.id) }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
